import React from 'react'

import "./style.css"

interface Props{
    title: string
}

const SectionHeader: React.FC<Props> =({title}) => {
    return (
    <h6 className="section-header">{title}</h6>
    )
}


export default SectionHeader